import { render, staticRenderFns } from "./RatesFormatter.vue?vue&type=template&id=65042e78&functional=true"
import script from "./RatesFormatter.vue?vue&type=script&lang=js"
export * from "./RatesFormatter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports